import { useState } from 'react';
import FormField from './FormField';
import FormWrapper from './FormWrapper';
import CredentialSecurityNotice from './CredentialSecurityNotice';
import { authTypeField, usernameField, passwordField } from './fieldConfigs';
import type { FieldConfig } from './types';

const baseUrlField: FieldConfig = {
    name: 'baseUrl',
    label: 'Base URL',
    type: 'url',
    required: true,
    placeholder: 'https://dicom-server.example.com/dicomweb',
};

const tokenField: FieldConfig = {
    name: 'token',
    label: 'Access Token',
    type: 'password',
    required: true,
    placeholder: 'Bearer token or OAuth access token',
    isCredential: true,
};

export default function DicomWebConfigForm() {
    const [authType, setAuthType] = useState<string>('none');

    return (
        <FormWrapper>
            <CredentialSecurityNotice />
            <FormField config={baseUrlField} />
            <FormField config={authTypeField(value => setAuthType(value as string))} />

            {authType === 'basic' && (
                <>
                    <FormField config={{ ...usernameField, placeholder: 'Username' }} />
                    <FormField config={{ ...passwordField, placeholder: 'Password' }} />
                </>
            )}

            {(authType === 'bearer' || authType === 'oauth2') && <FormField config={tokenField} />}
        </FormWrapper>
    );
}
